// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2fFQW","content":"LoadingAlert_content__3K1ez"};